import _ from 'lodash';
import { mapMutations } from 'vuex';
import DataLayer from '@/helpers/dataLayer.js';

export default {
	methods: {
		...mapMutations('contracting', ['setCurrentPage']),
		async handleNext() {
			this.beforeHandleNext().then(routeTo => {
				const currentPage = _.findIndex(this.$router.options.routes[1].children, child => {
					return child.name === routeTo;
				});

				this.setCurrentPage(currentPage);

				this.$scrollTo('.statebar', 500);

				this.$router.push({
					name: routeTo,
					params: this.$route.params,
				});

				if (_.has(this.$route, 'meta')) {
					if (_.has(this.$route.meta, 'dataLayerEvent')) {
						DataLayer.setEvent(this.$route.meta.dataLayerEvent);
					}
				}
			});
		},
		handlePrev() {
			this.beforeHandlePrev().then(routeTo => {
				this.$router.push({
					name: routeTo,
					params: this.$route.params,
				});
			});
		},
		scrollIntoViewWithOffset(selector, offset = 30) {
			window.scrollTo({
				behavior: 'smooth',
				top:
					document.querySelector(selector).getBoundingClientRect().top -
					document.body.getBoundingClientRect().top -
					offset,
			})
		},
	},
};
